// extracted by mini-css-extract-plugin
export default {"title":"OpportunityName_title__jcocj","main":"OpportunityName_main__Sabba","mandatory":"OpportunityName_mandatory__xh31J"};